var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 88.65 60.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e5f1fb;}.cls-2{fill:none;stroke:#000;stroke-linecap:round;stroke-miterlimit:10;stroke-width:5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "windAsset 147colored") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M80.66,30.91a11,11,0,0,0-2.14-4.18,11,11,0,0,0-2.72-2.56,11.72,11.72,0,0,0-4.64-1.72c-.23,0-.51-.36-.62-.61-2.11-5.17-6.51-8-12.05-7.45a19.34,19.34,0,0,0-4,1.07A1.2,1.2,0,0,1,53.16,15,13.55,13.55,0,0,0,48,10.52a15.18,15.18,0,0,0-2.31-.9c-.4-.12-.81-.23-1.23-.32a11.32,11.32,0,0,0-3.34-.2c-.5,0-1,.09-1.35.15-.65.11-1.12.22-1.29.27a.66.66,0,0,0-.15.05,23.54,23.54,0,0,0-4.69,2.32,33,33,0,0,0-3.86,3.81l-.11,0a12.52,12.52,0,0,0-5.83-1.52,10.84,10.84,0,0,0-5.14,1.24,12.16,12.16,0,0,0-5.32,5.73,2.44,2.44,0,0,1-1.52,1.18,12.26,12.26,0,0,0-3.19,1.09,10.62,10.62,0,0,0-4,3.59c-.17.25-.33.49-.48.75A13.29,13.29,0,0,0,2.69,31.6a10.26,10.26,0,0,0,0,3.81A11.36,11.36,0,0,0,12,44.82a1.31,1.31,0,0,1,1.11,1,11.26,11.26,0,0,0,9.35,7.3A11.07,11.07,0,0,0,28.93,52a1.12,1.12,0,0,1,1.41.36,14,14,0,0,0,22.74.12,1.12,1.12,0,0,1,1.41-.36,11.39,11.39,0,0,0,15.93-6.3.92.92,0,0,1,.87-.65A11.4,11.4,0,0,0,80.66,30.91Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 78.15,
    y1: 21.73,
    x2: 86.15,
    y2: 13.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 70.06,
    y1: 13.22,
    x2: 78.06,
    y2: 4.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 56.44,
    y1: 10.76,
    x2: 64.44,
    y2: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M45.34,10c-.4-.11-.81-.22-1.23-.31a11.19,11.19,0,0,0-3.32-.19c-.5,0-.95.1-1.34.16a12.23,12.23,0,0,0-1.36.3,23.74,23.74,0,0,0-4.73,2.36,32.69,32.69,0,0,0-3.82,3.81c.09,0,0,0-.12-.06a12.75,12.75,0,0,0-5.81-1.48,10.82,10.82,0,0,0-5.1,1.26A12.23,12.23,0,0,0,13.05,22a1.23,1.23,0,0,1-.84.66,12.55,12.55,0,0,0-3.64,1.19,10.65,10.65,0,0,0-4,3.6c-.16.24-.32.48-.47.74a13.17,13.17,0,0,0-1.46,3.88,9.94,9.94,0,0,0,0,3.8A11.31,11.31,0,0,0,12,45.22a1.27,1.27,0,0,1,1.11,1,11.25,11.25,0,0,0,9.34,7.22A11,11,0,0,0,29,52.23a1.08,1.08,0,0,1,1.34.38,13.87,13.87,0,0,0,22.9-.41.51.51,0,0,1,.68-.17,11.35,11.35,0,0,0,16.27-6.12.92.92,0,0,1,.86-.65A11.37,11.37,0,0,0,80.26,31"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/wind.f9e79d493e2fd83a55bd33db6ca7f43c.svg";
export { ForwardRef as ReactComponent };